export enum UserType {
  TEAM = "Team",
  INDIVIDUAL = "Individual",
}
export enum IndividualSubscriptionTiers {
  Starter = "Starter",
  Professional = "Professional",
}
export enum TeamSubscriptionTiers {
  Starter = "Starter",
  Professional = "Professional",
  Enterprise = "Enterprise",
}

export type SubscriptionTier =
  | TeamSubscriptionTiers
  | IndividualSubscriptionTiers;

export enum UserRole {
  OWNER = 1,
  ADMIN = 2,
  USER = 3,
  MODERATOR = 4,
  ROOT = 5,
}
export enum PayType {
  HOURLY = 1,
  MILESTONE = 2,
}

export enum EntityStatus {
  ACTIVE = 1,
  ARCHIVED = 2,
  SUSPENDED = 3,
}
export enum Delegates {
  PROJECT_ASSIGNMENT = 1,
  CREATE_PROJECT = 2,
  ADD_MEMBER = 3,
  TIME_APPROVAL = 4,
  TEAM_REPORTS = 5,
  CLONE_PROJECT = 6,
  DELETE_PROJECT = 7,
  UPDATE_PROJECT = 8,
  LIST_PROJECTS = 9,
  LIST_MEMBERS = 10,
  UPDATE_MEMBER = 11,
  DELETE_MEMBER = 12,
  RESET_PROJECTS = 13,
  RESET_TRACKED_TIME = 14,
  RESET_CLIENTS = 15,
  RESET_MILESTONES = 16,
  TIMETRACKING_REPORTS = 17,
  PROJECT_REPORTS = 18,
  LIST_CLIENTS = 19,
  CREATE_CLIENT = 20,
  LIST_INVOICES = 21,
  CREATE_INVOICE = 22,
  BUSSINESS = 23,
  DATA_CLEANUP = 24,
  CONFIGRANTION = 25,
  LIST_BILLS = 26,
  CREATE_BILL = 27,
  NOTIFICATIONS = 28,
  ADD_MILESTONE = 29,
  LIST_MILESTONES = 30,
  GENERATE_PROJECT_REPORT = 31,
  BONUS = 32,
  ARCHIVE_CLIENTS = 33,
  EDIT_CLIENTS = 34,
  EDIT_INVOICE = 35,
  DELETE_INVOICE = 36,
  EDIT_BILL = 37,
  DELETE_BILL = 38,
  EDIT_MILESTONE = 39,
}
export enum HistoryLimits {
  TASKS_COUNT = "task_count",
  CLIENTS_COUNT = "client_count",
  INVOICES_COUNT = "invoice_count",
  MEMBERS_COUNT = "member_count",
  SUPERVISORS_COUNT = "supervisors_count",
  REPORTS_COUNT = "report_count",
  PROJECTS_COUNT = "project_count",
  MILESTONES_COUNT = "milestone_count",
  TIME_TRACKING_REPORT_HISTORY = "time_tracking_history_days",
  TASK_HISTORY = "task_history_days",
  TASK_DETAILS_REPORT_HISTORY = "task_details_report_history_days",
}
